import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { BehaviorSubject, Observable, throwError } from 'rxjs';
import { LocalStorageService } from './local-storage.service';

@Injectable({
  providedIn: 'root'
})
export class IpService {
  APIKEY = 'isyh067e1n5gpoq8'
  private currentIpSubject: BehaviorSubject<any>
  public currentIp: Observable<any>
  constructor(
    private http: HttpClient,
    private storage: LocalStorageService
  ) {
    this.currentIpSubject = new BehaviorSubject<any>(this.storage.getItem('currentIp'))
    this.currentIp = this.currentIpSubject.asObservable()
  }

  public get currentIpValue(): any {
    return this.currentIpSubject.value
  }

  removeCurrentIp() {
    this.storage.setItem('currentIp', undefined)
    this.storage.removeItem('currentIp')
    this.currentIpSubject.next(null)
  }

  setCurrentIp(cart: any) {
    this.storage.setItem('currentIp', cart)
    this.currentIpSubject.next(cart)
  }

  returnIpAddress() {
    const stupidHeaders = new HttpHeaders().set('Access-Control-Allow-Origin', '*')
    const stupidOptions = {
      headers: stupidHeaders
    }
    return this.http.get(`https://api.ipregistry.co?key=${this.APIKEY}&fields=ip,location.country.code`, stupidOptions).pipe(
      map(data => {
        this.setCurrentIp(data)
        return data
      })
    )
  }

}
